<template>
  <div class="relative flex justify-center rounded-md bg-grey-35 p-[2px]">
    <ui-view-toggle-item v-for="view in views" :key="view" :hazard-view-type="view" class="z-20" />
    <!-- active slider -->
    <div
      class="absolute left-[2px] top-[2px] z-0 h-7 w-12 rounded bg-primary-400 transition-transform duration-200 2xs:w-14"
      :style="{ transform: `translateX(${sliderTranslate}px)` }"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { useHazardsStore, HazardView } from '@/features/hazards';
import { useBreakpoints } from '@vueuse/core';
import { BREAKPOINTS } from '@/constants/index';
import { computed } from 'vue';
import { showBothHazardView } from '@/common/helpers/sizes';

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller('2xs');
const hazards = useHazardsStore();

const views = computed<HazardView[]>(() => (showBothHazardView.value ? [HazardView.Both] : []).concat([HazardView.Map, HazardView.List]));

const sliderTranslate = computed<number>(() => {
  // First, determine the width of every item
  const itemWidth = isMobile.value ? 48 : 56;

  // Then, determine how far to move the slider
  return itemWidth * views.value.indexOf(hazards.activeView);
});
</script>
